import { render } from "./trust-data-accounting-software.html?vue&type=template&id=64bdc7e8&scoped=true&ts=true&external"
import script from "./trust-data-accounting-software.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-accounting-software.ts?vue&type=script&lang=ts&external"

import "./trust-data-accounting-software.scss?vue&type=style&index=0&id=64bdc7e8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bdc7e8"]])

export default __exports__